import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function useSocialsList() {
    const isSocialsFormSidebarActive = ref(false);
    const catsData = ref([]);
    const toast = useToast();
    const socials = ref(null);
    const refSocialsListTable = ref(null);
    const tableColumns = [
      { key: '', label: '', sortable: false },
      { key: 'image', label: 'Image', sortable: false, tdClass:'width-200 p-1' },

        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'category_name', label: 'Category Name', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },


    ];
    const socialsData = ref({});
    const perPage = ref(10)
    const totalSocials = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)
    const catFilter = ref(null);
    const dataMeta = computed(() => {
      const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
      const to = Math.min(
        totalSocials.value,
        perPage.value * currentPage.value
      );
      return {
        from,
        to,
        of: totalSocials.value,
      }
    })
    
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    
    store.dispatch('app-socials/fetchCats', {
      sites_id: getLocalSite.id
    })
    .then(response => {
      catsData.value = response.data.data
    })
    const refetchData = () => {
        fetchData()
        //refSocialsListTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery, statusFilter,catFilter], () => {
      fetchData()
    })
    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        store
          .dispatch('app-socials/fetchData', {
            limit: perPage.value,
            offset:offset,
            keywords: searchQuery.value,
            
            category_id:catFilter.value,
            order_by:'ordering_count ASC',
            sites_id: getLocalSite.id,
            
              /* page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            status: statusFilter.value,*/
          })
          .then(response => {
           
            socials.value  = response.data.data
             // console.log('socials',socials);
            const total = response.data.total;
            //callback(socials)
            totalSocials.value = total
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching invoices' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const updateSocials = (data)=>{

      socialsData.value = data;
      isSocialsFormSidebarActive.value = true;
    }
    const deleteData = (id) => {
        //fetchDeleteProperty
        store.dispatch('app-socials/deleteSocials',id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete User",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
    
        })
        //console.log('id', id);
        
      }

    const updateServicesOrdering = ()=>{
     
      store.dispatch('app-socials/updateServicesOrdering',socials.value)
    }
    const resolveSocialsStatusVariant = status => {
       
        if (status) return 'success'
        if (!status) return 'secondary'
        return 'primary'
    }
    const resolveSocialsStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }
    return {
        isSocialsFormSidebarActive,
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totalSocials,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refSocialsListTable,
    
        statusFilter,
        catFilter,
        deleteData,

        socialsData,
        catFilter,
        catsData,
        updateSocials,
        refetchData,
        resolveSocialsStatusVariant,
        resolveSocialsStatusnameVariant,
        socials,
        updateServicesOrdering
    }
}